// /src/components/FloatingSideButtons.jsx
import React from "react";
import "./FloatingSideButtons.css";

const DEFAULT_BUTTONS = [
  { id: "floating-btn-1", label: "TEST", action: "test" },
  { id: "floating-btn-2", label: "DEMO", action: "demo" },
];

export default function FloatingSideButtons({ buttons = DEFAULT_BUTTONS, hidden = false }) {
  if (!Array.isArray(buttons) || buttons.length === 0) return null;

  const dispatch = (name, detail) =>
    window.dispatchEvent(new CustomEvent(name, { detail }));

  return (
    <div
      className="floating-side-buttons"
      data-hidden={hidden ? "true" : "false"}
      aria-hidden={hidden}
      inert={hidden ? "" : undefined}
    >
      {buttons.map((item, index) => {
        const { id, label, action, onClick: onClickProp, ...restProps } = item || {};
        const key = id || label || `floating-side-button-${index}`;

        const onClick = (e) => {
          if (typeof onClickProp === "function") {
            try { onClickProp(e); } catch {}
          }
          if (!onClickProp) {
            const upper = String(label).toUpperCase();
            if (action === "demo" || upper === "DEMO") {
              dispatch("radiomonitor:demo-open", {});
            } else if (action === "test" || upper === "TEST") {
              dispatch("radiomonitor:test-open", {});
            }
          }
        };

        return (
          <button
            key={key}
            type="button"
            className="floating-side-buttons__btn"
            onClick={onClick}
            data-action={action}
            {...restProps}
          >
            <span className="floating-side-buttons__label">{label || "—"}</span>
          </button>
        );
      })}
    </div>
  );
}
